import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2 contact-item" }
const _hoisted_2 = { class: "item-container" }
const _hoisted_3 = { class: "ml-2" }

interface HomeContactItemProps {
    icon: string;
    label: string;
}

interface HomeContactItemEmits {
    (e: 'on:click'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeContactItem',
  props: {
    icon: {},
    label: {}
  },
  emits: ["on:click"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        icon: props.icon
      }, null, 8, ["icon"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.label), 1)
    ]),
    _createVNode(_component_v_btn, {
      variant: "text",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('on:click')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: props.icon,
          class: "mr-1"
        }, null, 8, ["icon"])
      ]),
      _: 1
    })
  ]))
}
}

})